import { BookingFlowShell, type BookingFlowShellConfig } from '../../../booking-flow/BookingFlowShell';
import { ApprovalPassengerStep } from '../../../components/booking/ApprovalPassengerStep';
import {
  approvalEmployeeId,
  corporateMaxBudget,
  needsCorporateApproval,
} from '../../../components/booking/corporateApproval';
import { transferFlowConfig, type TransferFlowState } from '../flowConfig';
import { transferResumeAdapter } from '../resume';
import { TransferSearchStep } from '../components/TransferSearchStep';
import { TransferResultsStep } from '../components/TransferResultsStep';
import { TransferPassengerStep } from '../components/TransferPassengerStep';
import { TransferPrebookStep } from '../components/TransferPrebookStep';
import { TransferPaymentStep } from '../components/TransferPaymentStep';
import { TransferFinalizeStep } from '../components/TransferFinalizeStep';
import { TransferDocumentStep } from '../components/TransferDocumentStep';

/** `TransferFlowState` → kurumsal onay kapısı girdisi (eski `TransferFlowInner`'daki
 *  `gate` nesnesi + tek-yolculu kontrolü). */
function transferApprovalActive(state: TransferFlowState, sessionEmployeeId: number | null) {
  const sr = state.searchRequest;
  const gate = {
    cart: state.cart,
    searchEmployeeId: sr?.employeeID,
    extraOverBudget: state.selectedVehicle?.isOutBudget,
    extraMaxBudget: state.selectedVehicle?.maxBudget,
  };
  const employeeId = approvalEmployeeId(gate, sessionEmployeeId);
  const singlePax = sr?.adtPaxCount === 1 && !sr?.chdPaxCount && !sr?.infPaxCount;
  if (!singlePax || !needsCorporateApproval(gate) || !employeeId) return null;
  return { employeeId, maxBudget: corporateMaxBudget(gate) };
}

const shellConfig: BookingFlowShellConfig<TransferFlowState> = {
  title: 'Transfer',
  flowConfig: transferFlowConfig,
  resumeAdapter: transferResumeAdapter,
  sentForApproval: {
    isSent: (s) => !!s.sentForApproval,
    passengerStepId: 'updatePassengers',
    reservationPath: '/transfer/reservations',
    message:
      'Transfer onaya gönderilmiştir. Yöneticiniz onayladığında rezervasyon listenizden ödemeye devam edebilirsiniz.',
  },
  approvalGate: {
    passengerStepId: 'updatePassengers',
    isActive: transferApprovalActive,
    render: ({ flow, running, employeeId, maxBudget }) => (
      <ApprovalPassengerStep
        employeeId={employeeId}
        maxBudget={maxBudget}
        productLabel="transfer"
        loading={running}
        onSubmit={(passengers, contact, billingInformation) => {
          flow
            .runStep({ passengers, contact, billingInformation, sentForApproval: true })
            .catch(() => undefined);
        }}
      />
    ),
  },
  renderStep: {
    search: () => <TransferSearchStep />,
    allocate: () => <TransferResultsStep />,
    updatePassengers: () => <TransferPassengerStep />,
    prebook: () => <TransferPrebookStep />,
    payment: () => <TransferPaymentStep />,
    finalize: () => <TransferFinalizeStep />,
    document: () => <TransferDocumentStep />,
  },
};

export default function TransferFlowPage() {
  return <BookingFlowShell config={shellConfig} />;
}
